import axios from 'axios';

const baseUrl = location.protocol + '//' + location.host + "/api";

const api = {
  createNewGame: (grade, players, timeLimit) => {
    return axios.post(`${baseUrl}/createNewGame`, {'grade':grade,'player_count': players, 'time_limit': timeLimit});
  },
  getGameByCode: (gameCode) => {
    return axios.get(`${baseUrl}/getGameByCode/${gameCode}`);
  },
  getQrCode: (gameId) => {
    return axios.get(`${baseUrl}/qrcode/${gameId}`);
  },
  registerPlayer: (gameId, playerId, username) => {
    return axios.post(`${baseUrl}/registerPlayer/`, {'game_id':gameId, 'player_id':playerId, 'username': username});
  },
  getAvatarSettings: () => {
    return axios.get(`${baseUrl}/getAvatarSettings`);
  },
  getAvatar: (groupId) => {
    return axios.get(`${baseUrl}/getAvatar/${groupId}`);
  },
  saveAvatar: (groupId, avatarId, section) => {
    return axios.post(`${baseUrl}/saveAvatar/`, {'group_id':groupId, 'avatar_id':avatarId, 'section': section});
  },
  updateAvatar: (groupId, avatarId, section) => {
    return axios.post(`${baseUrl}/updateAvatar/`, {'group_id':groupId, 'avatar_id':avatarId, 'section': section});
  },
  getGroupByPlayer: (playerId) => {
    return axios.post(`${baseUrl}/getGroupByPlayer/`, {'player_id':playerId});
  },
  getGroupsByGame: (gameId) => {
    return axios.post(`${baseUrl}/getGroupsByGame/`, {'game_id':gameId});
  },
  confirmGroup: (playerId) => {
    return axios.post(`${baseUrl}/confirmGroup/`, {'player_id': playerId});
  },
  selectRole: (playerId, role) => {
    return axios.post(`${baseUrl}/selectRole/`, {'player_id': playerId, 'role': role});
  },
  unselectRole: (playerId) => {
    return axios.post(`${baseUrl}/unselectRole/`, {'player_id': playerId});
  },
  createQuestions: (playerId) => {
    return axios.post(`${baseUrl}/createQuestions/`,{'player_id': playerId});
  },
  getGameStatus: (groupId) => {
    return axios.post(`${baseUrl}/getGameStatus/`, {'group_id': groupId});
  },
  getGroupsStatus: (gameId) => {
    return axios.post(`${baseUrl}/getGroupsStatus/`, {'game_id': gameId});
  },
  getGroupsStatusTest: (gameId) => {
    return axios.post(`${baseUrl}/getGroupsStatusTest/`, {'game_id': gameId});
  },
  startMission: (groupId) => {
    return axios.post(`${baseUrl}/startMission/`, {'group_id': groupId});
  },
  completeMission: (groupId, missionId, answer) => {
    return axios.post(`${baseUrl}/completeMission/`, {'group_id': groupId, 'mission_id': missionId, 'answer': answer});
  },
  completeSubGame: (groupId, missionId, subGameType) => {
    return axios.post(`${baseUrl}/completeSubGame/`, {'group_id': groupId, 'sub_game_type': subGameType, 'mission_id': missionId});
  },
  getLocale: (lng) => {
    return axios.get(`${baseUrl}/locales/${lng}`);
  },
  addLocale: (lng, key) => {
    return axios.post(`${baseUrl}/locales/add/${lng}`, {...key});
  },
  resetPlayer: (playerId) => {
    return axios.post(`${baseUrl}/resetPlayer/`, {'player_id': playerId});
  },
  resetGroup: (groupId) => {
    return axios.post(`${baseUrl}/resetGroup/`, {'group_id': groupId});
  },
  stopGame: (gameId) => {
    return axios.post(`${baseUrl}/stopGame/`, {'game_id': gameId});
  },
};

export default api;